<div class="container">

  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>

  <form class="card-form" [formGroup]="motorForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate >
    <div class="blue-top"></div>
    <div class="card-section top-section">
      <!-- only renders if claim isn't theft -->
      <h1>
        <b>{{ pageHeading }}</b>
      </h1>
      <h2>{{ pageSubheading }}</h2>

      <!-- <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          vehicleRegLabel
        }}</mat-label>
        <input matInput formControlName="vehicleReg" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['vehicleReg']">
          {{ formErrors["vehicleReg"] }}
        </mat-error>
      </mat-form-field> -->

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          ownerNameLabel
        }}</mat-label>
        <input matInput formControlName="ownerName" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['ownerName']">
          {{ formErrors["ownerName"] }}
        </mat-error>
      </mat-form-field>

      <mat-form-field
        appearance="outline"
        class="form-select"
        appFullYearDateFormat
      >
        <mat-label class="form-select-placeholder-unselected">{{
          theftDateLabel
        }}</mat-label>
        <input
          matInput
          (blur)="logErrors()"
          [min]="minDate"
          [max]="maxDate"
          [matDatepicker]="picker"
          readonly="true"
          (click)="picker.open()"
          formControlName="theftDate"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker> </mat-datepicker>
        <mat-error *ngIf="formErrors['theftDate']">
          {{ formErrors["theftDate"] }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          theftTimeLabel
        }}</mat-label>
        <input matInput type="time" formControlName="theftTime" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['theftTime']">
          {{ formErrors["theftTime"] }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-select">
        <mat-label class="form-select-placeholder-unselected">{{
          theftLocationLabel
        }}</mat-label>
        <input matInput formControlName="theftLocation" (blur)="logErrors()" />
        <mat-error *ngIf="formErrors['theftLocation']">
          {{ formErrors["theftLocation"] }}
        </mat-error>
      </mat-form-field>

      <p>{{ thirdPartyQuestion }}</p>
      <section class="row-div modified_checkbox" formGroupName="thirdParty">
        <div class="row-inner-div row-inner-div-left">
          <mat-checkbox formControlName="yes" (change)="onYesChange()">{{
            yesText
          }}</mat-checkbox>
        </div>
        <div class="row-inner-div row-inner-div-right">
          <mat-checkbox formControlName="no" (change)="onNoChange()">{{
            noText
          }}</mat-checkbox>
        </div>
      </section>
      <mat-error *ngIf="formGroupErrors['thirdParty']">
        {{ formGroupErrors["thirdParty"] }}
      </mat-error>

      <p style="margin-top: 20px;">{{ policeNotifiedQuestion }}</p>
      <section class="row-div modified_checkbox" formGroupName="policeNotified">
        <div class="row-inner-div row-inner-div-left">
          <mat-checkbox formControlName="yes" (change)="onYes2Change()">{{
            yesText
          }}</mat-checkbox>
        </div>
        <div class="row-inner-div row-inner-div-right">
          <mat-checkbox formControlName="no" (change)="onNo2Change()">{{
            noText
          }}</mat-checkbox>
        </div>
      </section>
      <mat-error *ngIf="formGroupErrors['policeNotified']">
        {{ formGroupErrors["policeNotified"] }}
      </mat-error>
      

      <div class="row-div margin-top-50">
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">{{ cancel }}</span>
        </button>
        <button mat-button type="submit" [disabled]="!motorForm.valid">
          <span class="button-text">{{ saveContinue }}</span>
        </button>
      </div>
    </div>
  </form>
</div>
